module.exports = __webpack_public_path__ + "static/img/menu-about-responsibility.827aeda8.png";